<template>
    <div class="bank-image" :class="{ expired: isOfferExpired }">
        <div class="pb-4 pt-2">
            <img
                :class="[orientation, { 'review-lender-image': showReviews }]"
                :src="offer.lender.logo.url"
                alt="Lender logo"
                @load="imgOrientation"
            />
        </div>

        <div class="w-100 d-flex justify-content-center mb-3" v-if="showReviews">
            <div
                class="review-block d-none d-md-flex"
                v-if="offer.lender.review.service === 'feefo' && offer.lender.review.id !== ''"
            >
                <img alt="Feefo service rating" :src="getReviewURL('feefo', offer.lender.review.id)" />
            </div>

            <div
                class="review-block d-flex d-md-flex justify-content-center w-100"
                v-if="offer.lender.review.service === 'reviews.io' && offer.lender.review.id !== ''"
            >
                <img class="p-0 review-image" :src="asset(`/v2/images/${reviewImage}`)" alt="" />
            </div>
        </div>

        <div class="terms_url w-100 text-center pr-4 pl-3 pb-2">
            <p class="mb-0">
                <span v-if="offer?.lender?.terms_url.terms_linktext">
                    <a :href="offer.lender.terms_url.terms_hyperlink" class="terms-url" target="_blank">
                        {{ offer.lender.terms_url.terms_linktext }}
                    </a>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['offer', 'isOfferExpired'],
    data() {
        return {
            showReviews: false,
            orientation: '',
            reviewImage: '',
        }
    },
    mounted() {
        if (this.offer.type === 'debt_solution' && this.territory === 'gbr') {
            this.showReviews = true
            this.reviewImage = this.themeSetting('moneyplus_review_image')
        }
    },
    methods: {
        getReviewURL(service, reviewId) {
            let reviewURL

            if (service === 'feefo') {
                reviewURL = `https://api.feefo.com/api/logo?merchantidentifier=${reviewId}&template=Service-Stars-White-175x44.png&smallonzero=true`
            } else if (service === 'trustpilot') {
                reviewURL = `https://widget.trustpilot.com/trustboxes/5419b6ffb0d04a076446a9af/index.html?templateId=5419b6ffb0d04a076446a9af&businessunitId=${reviewId}`
            } else if (service === 'reviews.io') {
                reviewURL = `https://widget.reviews.io/badge/widget?elementId=badge-100&version=2&store=${reviewId}&primaryClr=%23f4f4f4&neutralClr=%23f4f4f4&starsClr=%23f47c25&textClr=%23000`
            }

            return reviewURL
        },
        imgOrientation() {
            let img = new Image()
            img.src = this.offer.lender.logo.url

            if (img.naturalWidth < img.naturalHeight) {
                this.orientation = 'portrait'
            }
        },
    },
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
    },
}
</script>

<style lang="scss">
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.bank-image {
    align-items: center;
    border: 2px solid #ebebeb;
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    justify-content: center;
    max-width: 300px;
    min-height: 56px;
    padding: 0px 10px 5px;
    width: 100%;

    &.expired {
        opacity: 50%;
    }

    img {
        max-height: 100%;
        max-width: 100px;
        width: 100%;

        &.portrait {
            max-width: 75px;
            @media screen and (min-width: $bp-large) {
                max-width: 105px;
            }
        }

        @media screen and (min-width: $bp-large) {
            max-height: 100%;
            max-width: 150px;
        }
    }

    @media screen and (min-width: $bp-large) {
        border: none;
        border-right: 2px solid #ebebeb;
    }

    .terms_url {
        position: absolute;
        bottom: 0;
        line-height: 0.9;

        a {
            font-size: rem(11px);

            @media screen and (max-width: $bp-large) {
                font-size: rem(10px);
            }
        }

        p {
            padding-bottom: 2px;
        }
    }

    .review-image {
        min-width: 40%;

        @media screen and (min-width: $bp-medium) {
            min-width: 60%;
        }
    }

    .review-lender-image {
        min-width: 60%;
    }
}
</style>
